import { Component } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FieldDefinitionOption } from '@wdx/shared/utils';
import { BehaviorSubject } from 'rxjs';
import { BaseWdxFormControlClass } from '../../../abstract-classes/base-form-control.class';
import { IFormDynamicData } from '../../../interfaces';
import { ExtendedFieldDefinitionOption } from '../../../models';

@Component({
    selector: 'wdx-ff-radio-buttons-control',
    templateUrl: './form-radio-buttons-control.component.html',
    standalone: false,
})
export class FormRadioButtonsControlComponent extends BaseWdxFormControlClass {
    public fieldDefOptions$ = this.options$ as BehaviorSubject<
        FieldDefinitionOption[]
    >;

    constructor(
        public override controlContainer: ControlContainer,
        public override dynamicDataService: IFormDynamicData,
    ) {
        super(controlContainer, dynamicDataService);
    }
}
